import { Component, EventEmitter, Input, Output } from '@angular/core';
import { currencies } from '../../../constants/currencies.constants';
import { cancellationPolicyCodes } from '../../../constants/cancellation.constants';
import { AddOnExtraServices } from '../../../core/interfaces/add-on';

@Component({
  selector: 'app-addon-button',
  templateUrl: './addon-button.component.html',
  standalone: false
})
export class AddonButtonComponent {
  currencies = currencies;

  @Input() isMobile = false;
  @Input() optionValue: cancellationPolicyCodes | AddOnExtraServices;
  @Input() textContent: { title: string; description: string };
  @Input() price: number;
  @Input() offerCurrency: string;
  @Input() isSelected: boolean = false;
  @Input() isDisabled: boolean = false;

  @Output() updateSection: EventEmitter<{
    value: cancellationPolicyCodes | AddOnExtraServices;
    isSelected?: boolean;
  }> = new EventEmitter();

  get dataTestIdSuffix() {
    return this.optionValue.toLowerCase().replace(' ', '-');
  }

  onSelection(isSelectedState?: boolean) {
    this.updateSection.emit({
      value: this.optionValue,
      isSelected: isSelectedState
    });
  }
}
